import { Reveal } from "@/components/Reveal";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export const CtaBlock = () => (
  <section
    data-testid="cta-block-section"
    className="relative overflow-hidden bg-gradient-to-br from-gold-light via-gold to-gold-dark py-20 sm:py-24"
  >
    <div
      className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-white/20 blur-3xl"
      aria-hidden="true"
    />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <Reveal>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-navy">
          Nak Tahu Pilihan Yang Sesuai?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base sm:text-lg text-navy/80 leading-relaxed">
          Hantar satu mesej WhatsApp — perunding kami akan semak kelayakan anda
          secara percuma, hari ini juga.
        </p>
        <div className="mt-8">
          <WhatsAppButton
            location="cta_block"
            testId="cta-block-whatsapp-button"
            size="lg"
            pulse
          >
            WhatsApp Sekarang
          </WhatsAppButton>
        </div>
      </Reveal>
    </div>
  </section>
);
